/**
 * @file Custom Prints Master View.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import Helmet from 'react-helmet';

const propTypes = {
  route: PropTypes.object,
};

const ConsumerCustomPrintsMasterView = ({ route }) => {
  return (
    <Fragment>
      <Helmet>
        <title>Custom Prints &ndash; Waldo</title>
      </Helmet>

      {renderRoutes(route.routes)}
    </Fragment>
  );
};

ConsumerCustomPrintsMasterView.propTypes = propTypes;

export default ConsumerCustomPrintsMasterView;
